import { IState } from '../../store';

export const selectIsConfirmOpen = (state: IState): boolean => {
  return state.newbuildingBookedFromDeveloper.isConfirmOpen;
};
